import Vue from 'vue';
import { API_BASE_URL } from '@/config';
export default {
  project_dataset_delete (query) {
    return Vue.http.post(API_BASE_URL + 'v1/project/dataset/delete?' + query);
  }
};
